// extracted by mini-css-extract-plugin
export var Content = "styles-module--Content--071a4";
export var Image = "styles-module--Image--fcdb5";
export var Post = "styles-module--Post--28717";